var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"state-badge",class:'state-badge-' + _setup.badgeType},[_vm._v(" "+_vm._s(_setup.item)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }